import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'hdw-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() maxNumberOfPages: number = 4;
  @Input() rows: number;
  @Input() totalRecords: number;
  @Input() updateSelectedIndex: number;
  @Output() selectedIndexEmitter: EventEmitter<number>;
  public canShow: boolean;
  public totalPages: number;
  public startIndex: number;
  public endIndex: number;
  public selectedIndex: number;
  public pagesToRender: number[];
  constructor() {
    this.selectedIndexEmitter = new EventEmitter<number>();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalRecords']?.currentValue) {
      this.totalPages = Math.ceil(this.totalRecords / this.rows);
      this.canShow = this.totalRecords > this.rows;
      this.startIndex = 0;
      this.selectedIndex = 0;
      this.endIndex = this.totalPages > 2 ? 3 : this.totalPages;
      this.handlePagesToRender();
    }

    if (
      changes['updateSelectedIndex']?.currentValue !== null &&
      changes['updateSelectedIndex']?.currentValue !== undefined
    ) {
      this.handleUpdateSelectedIndex();
    }
  }

  public ngOnInit(): void {
    this.totalPages = Math.ceil(this.totalRecords / this.rows);
    this.canShow = this.totalRecords > this.rows;
    this.startIndex = 0;
    this.selectedIndex = 0;
    this.endIndex = this.totalPages > 2 ? 3 : this.totalPages;
    this.handlePagesToRender();
  }

  public handleNext(): void {
    this.selectedIndex = this.selectedIndex + 1;
    this.endIndex = this.endIndex + 1 <= this.totalPages ? this.endIndex + 1 : this.endIndex;
    this.startIndex = this.endIndex - 3;

    this.handlePagesToRender();
    this.handleEventEmitter();
  }

  public handleBack(): void {
    this.selectedIndex = this.selectedIndex - 1;
    this.startIndex = this.selectedIndex - 2 > 0 ? this.selectedIndex - 2 : 0;
    this.endIndex = this.startIndex + 3 < this.totalPages - 1 ? this.startIndex + 3 : this.totalPages - 1;

    this.handlePagesToRender();
    this.handleEventEmitter();
  }

  public handlePageClick(pageNumber: number): void {
    this.selectedIndex = pageNumber - 1;
    this.handleEventEmitter();
  }

  public handleJumpToEnd(): void {
    this.selectedIndex = this.totalPages - 1;
    this.startIndex = this.totalPages - 3;
    this.endIndex = this.totalPages;
    this.handlePagesToRender();
    this.handleEventEmitter();
  }

  public handleJumpToStart(): void {
    this.selectedIndex = 0;
    this.startIndex = 0;
    this.endIndex = this.totalPages > 2 ? 3 : this.totalPages;
    this.handlePagesToRender();
    this.handleEventEmitter();
  }

  private handlePagesToRender(): void {
    const pages: number[] = [];
    for (let i = this.startIndex; i < this.endIndex; i++) {
      pages.push(i + 1);
    }
    this.pagesToRender = pages;
  }

  private handleEventEmitter(): void {
    this.selectedIndexEmitter.emit(this.selectedIndex);
  }

  public canShowJumpToStart(): boolean {
    return this.selectedIndex > 0 && this.totalPages > this.maxNumberOfPages;
  }

  public canShowJumpToEnd(): boolean {
    return this.selectedIndex !== this.totalPages - 1 && this.totalPages > this.maxNumberOfPages;
  }

  private handleUpdateSelectedIndex(): void {
    this.selectedIndex = this.updateSelectedIndex;
    if (this.selectedIndex === 0) {
      this.startIndex = 0;
      this.endIndex = this.totalPages > 2 ? 3 : this.totalPages;
    } else if (this.selectedIndex === this.totalPages - 1) {
      this.endIndex = this.totalPages;
      this.startIndex = this.totalPages - 3 > 0 ? this.totalPages - 3 : 0;
    } else {
      this.startIndex = this.selectedIndex - 1;
      this.endIndex = this.selectedIndex + 2;
    }
    this.handlePagesToRender();
  }
}
